import { render, staticRenderFns } from "./PublisherReferences.vue?vue&type=template&id=79a43302"
import script from "./PublisherReferences.vue?vue&type=script&lang=js"
export * from "./PublisherReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports